import { t, useI18n } from "@bookingcom/lingojs-react";
import useSearchFiltersController from "../../useSearchFiltersController.js";
import { useCallback, useEffect, useRef, useState } from "react";
import debounce from "lodash/debounce";
import flights_funnel_layover_price_airport_filter_web from "../../../../../utils/experiments/funnel/flights_funnel_layover_price_airport_filter_web.js";
const useDebouncedCallback = (callback, delay) => {
    const debouncedFn = useRef();
    useEffect(() => {
        debouncedFn.current = debounce((...args) => {
            callback(...args);
        }, delay);
        return () => {
            debouncedFn.current?.cancel();
        };
    }, [callback, delay]);
    return useCallback((...args) => {
        debouncedFn.current?.(...args);
    }, []);
};
export const useLayoverDurationFilterController = () => {
    const i18n = useI18n();
    const { layoverDuration } = useSearchFiltersController();
    const [value, setValue] = useState(layoverDuration.value);
    const lastCommittedValueRef = useRef(layoverDuration.value);
    useEffect(() => {
        setValue(layoverDuration.value);
        lastCommittedValueRef.current = layoverDuration.value;
    }, [layoverDuration.value]);
    const debouncedLayoverDurationSet = useDebouncedCallback(layoverDuration.set, 300);
    const handleOnChange = (value) => {
        setValue(value);
        flights_funnel_layover_price_airport_filter_web.goals.layover();
    };
    const handleChangeCommit = (newValue) => {
        if (newValue !== lastCommittedValueRef.current) {
            lastCommittedValueRef.current = newValue;
            debouncedLayoverDurationSet(newValue);
        }
    };
    return {
        isFilterAvailable: layoverDuration.options.max > 0 && layoverDuration.options.max !== layoverDuration.options.min,
        resetLabel: i18n.trans(t("flights_filter_reset")),
        showReset: layoverDuration.touched,
        onClickReset: layoverDuration.reset,
        min: layoverDuration.options.min,
        max: layoverDuration.options.max,
        value,
        ariaLabel: i18n.trans(t("a11y_flights_filter_layover_duration_announce")),
        label: i18n.trans(t("flights_filters_duration_layover_time")),
        onChange: (value) => handleOnChange(value),
        onChangeCommit: handleChangeCommit,
        renderTooltipValue: (value) => i18n.trans(t("flights_filters_layover_hours", {
            variables: { num_hours: value.toString() },
            num_exception: value
        })),
        renderValue: (value) => i18n.trans(t("flights_filters_layover_hours", {
            variables: { num_hours: value.toString() },
            num_exception: value
        })),
        keyForRemount: `layover-${layoverDuration.options.min}-${layoverDuration.options.max}`
    };
};
